// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xa1MV","content":"styles_content__kuIOJ","tableWrap":"styles_tableWrap__27num"};